import { storeProduct } from "@/stores/product.js";
import { storeAddition } from "@/stores/addition.js";
import { storeGift } from "@/stores/gift.js";
import $axios from "@/axios";
import router from "@/router";

export default {
  //請求商品
  get: async function (path, query, perPage = storeProduct.perPage) {
    await $axios
      .post("/api/admin/product_get.php", { query: query, perPage: perPage })
      .then(function (res) {
        if (res.data.result == "pass") {
          let arr = res.data.products;
          initResponseData_Products(arr);
          storeProduct.products = arr;
          storeProduct.page = res.data.page;
          storeProduct.pageCount = res.data.page_count;
          if (JSON.stringify(query) != "{}" && query !== undefined) {
            if (query.page !== undefined) {
              if (parseInt(query.page) !== parseInt(res.data.page)) {
                let cloneQuery = JSON.parse(JSON.stringify(query));
                cloneQuery.page = parseInt(res.data.page);
                router.replace({ path: path, query: cloneQuery });
              }
            }
          }
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  unbind_additions: async function (additions) {
    await $axios
      .post("/api/admin/product_unbind_additions.php", { arr: additions })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeAddition.additions = res.data.additions;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  unbind_gifts: async function (gifts) {
    await $axios
      .post("/api/admin/product_unbind_gifts.php", { arr: gifts })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeGift.gifts = res.data.gifts;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  //請求促銷商品清單
  getPromotionProducts: async function (query, perPage) {
    return await $axios.post("/api/admin/product_get.php", { query: query, perPage: perPage });
  },
};

//將商品請求返回的json數據解析還原
function initResponseData_Products(arr) {
  arr.map((item) => {
    item.loading = false; //loading屬性僅用於前端，保存到伺服器時不會保存這個屬性
  });
}
